module.exports = __webpack_public_path__ + "static/media/czujnik1.dc736477.svg";